import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ReportId } from '../model';

export const getReportsFragment = (
	reportId: ReportId,
	issueKey: IssueKey,
	timescaleId?: number,
): string =>
	timescaleId !== undefined
		? `${timescaleId}/${String(issueKey)}`
		: `${String(reportId)}/timescale/2/${String(issueKey)}`;
